module.exports = __webpack_public_path__ + "static/img/p_company.ec3abbd4.png";